module.exports = __webpack_public_path__ + "static/media/madhucon6.22ddeb92.png";